import { Grid, Stack, Typography, useTheme } from '@mui/material';
import usePlanStore from '../../../../../../store/planStore';

function PlanSummaryGeneralInfo() {
  const { storedCountryForms, savedGeneralInfoState } = usePlanStore();
  const theme = useTheme();
  return (
    <Grid container>
      <Grid item xs={12} pt="12px" px="16px" pb="16px">
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: '18px',
            textTransform: 'uppercase',
            color: theme.palette.textLight.main,
            pb: '18px',
          }}
        >
          General info
        </Typography>
        <Grid container>
          <Grid item xs={5} pr="16px">
            <Stack>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '12px',
                  textTransform: 'uppercase',
                  color: theme.palette.textLight.main,
                  pb: '13px',
                }}
              >
                Plan name
              </Typography>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '12px',
                  textTransform: 'uppercase',
                  color: theme.palette.textLight.main,
                  opacity: 0.7,
                  wordBreak: 'break-word',
                }}
              >
                {savedGeneralInfoState?.campaignName}
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={1} px="16px">
            <Stack>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '12px',
                  textTransform: 'uppercase',
                  color: theme.palette.textLight.main,
                  pb: '13px',
                }}
              >
                Campaign Code
              </Typography>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '12px',
                  textTransform: 'uppercase',
                  color: theme.palette.textLight.main,
                  opacity: 0.7,
                }}
              >
                {savedGeneralInfoState?.campaignCode}
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={1} px="16px">
            <Stack>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '12px',
                  textTransform: 'uppercase',
                  color: theme.palette.textLight.main,
                  pb: '13px',
                }}
              >
                Division
              </Typography>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '12px',
                  textTransform: 'uppercase',
                  color: theme.palette.textLight.main,
                  opacity: 0.7,
                }}
              >
                {savedGeneralInfoState?.division}
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={1} px="16px">
            <Stack>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '12px',
                  textTransform: 'uppercase',
                  color: theme.palette.textLight.main,
                  pb: '13px',
                }}
              >
                Brand
              </Typography>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '12px',
                  textTransform: 'uppercase',
                  color: theme.palette.textLight.main,
                  opacity: 0.7,
                }}
              >
                {savedGeneralInfoState?.brand}
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={3} px="16px">
            <Stack>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '12px',
                  textTransform: 'uppercase',
                  color: theme.palette.textLight.main,
                  pb: '13px',
                }}
              >
                Category
              </Typography>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: '12px',
                  textTransform: 'uppercase',
                  color: theme.palette.textLight.main,
                  opacity: 0.7,
                  wordBreak: 'break-word',
                }}
              >
                {savedGeneralInfoState?.category}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default PlanSummaryGeneralInfo;
